export type Review = {
  reviewType: ReviewType;
  review: string;
  author?: string;
  authorImage?: string;
};

export enum ReviewType {
  VIDEO = "video",
  IMAGE = "image",
  TEXT = "text",
}
// https://placehold.co/800x400/2d3748/ffffff?text=Papaya+Salad
export const mockReview = [
  {
    reviewType: "text",
    review: "ตั้งแต่กินปลาร้าเชฟไพรฑูรย์ก็ไม่กินยี่ห้ออื่นอีกเลย ซื้อเป็นแพ็คติดบ้านไว้เลย ขาดไม่ได้",
    author: "คุณเมล์",
    authorImage: "https://placehold.co/36x36/2d3748/ffffff?text=M",
  },
  {
    reviewType: "text",
    review: "หนึ่งเดียว ยืนหนึ่ง ที่กินอยู่ตอนนี้เชฟไพรฑูรย์เท่านั้น",
    author: "คุณโอ๋",
    authorImage: "https://placehold.co/36x36/2d3748/ffffff?text=A",
  },
  {
    reviewType: "video",
    review:
      "https://firebasestorage.googleapis.com/v0/b/cool-splice-468214-q7.firebasestorage.app/o/video%2Fclip-review-1-sd.mp4?alt=media&token=a8ad1df7-58b6-405f-8330-cf334d44667e",
  },
  {
    reviewType: "text",
    review:
      "ลองมาหลายยี่ห้อ เชฟไพรฑูรย์คือที่สุดของฉัน ตำบักหุ่ง แกงอ่อม แกงหน่อไม้ แซ่บค่ะ",
    author: "คุณ Pcbeer",
    authorImage: "https://placehold.co/36x36/2d3748/ffffff?text=P",
  },
  {
    reviewType: "video",
    review:
      "https://firebasestorage.googleapis.com/v0/b/cool-splice-468214-q7.firebasestorage.app/o/video%2Fclip-review-2-sd.mp4?alt=media&token=a49cf434-8153-4c20-9f0b-999e66f78405",
  },
  {
    reviewType: "text",
    review: "กินมา 9 ปีแล้วค่ะ จากใจ 100 100 100 ไม่หัก",
    author: "คุณบุษบา",
    authorImage: "https://placehold.co/36x36/2d3748/ffffff?text=B",
  },
  {
    reviewType: "text",
    review: "การันตีความแซ่บนัว ต้องยกให้ปลาร้าเชฟไพรฑูรย์จ้า",
    author: "คุณปรัชญา",
    authorImage: "https://placehold.co/36x36/2d3748/ffffff?text=P",
  },
  {
    reviewType: "video",
    review:
      "https://firebasestorage.googleapis.com/v0/b/cool-splice-468214-q7.firebasestorage.app/o/video%2Fclip-review-3-sd.mp4?alt=media&token=cc730494-199d-46c5-83a2-7a4d386f211b",
  },
  {
    reviewType: "text",
    review:
      "อร่อยจริงค่ะ ลองมาหมดแล้วจบที่เชฟไพรฑูรย์",
    author: "คุณดวง",
    authorImage: "https://placehold.co/36x36/2d3748/ffffff?text=D",
  },
  {
    reviewType: "video",
    review:
      "https://firebasestorage.googleapis.com/v0/b/cool-splice-468214-q7.firebasestorage.app/o/video%2Fclip-review-4-sd.mp4?alt=media&token=3d158279-e0a7-4077-bac8-128ac4503608",
  },
  {
    reviewType: "text",
    review: "ยี่ห้อนี้ตำบักหุ่งแซบ อยู่บ้านซื้อแบบแกนลอนเลย",
    author: "คุณปราณี",
    authorImage: "https://placehold.co/36x36/2d3748/ffffff?text=P",
  },
  {
    reviewType: "text",
    review: "ใช้ทุกวันอร่อยเข้มข้นจริงๆ ค่ะ",
    author: "คุณ Nook",
    authorImage: "https://placehold.co/36x36/2d3748/ffffff?text=N",
  },
  {
    reviewType: "video",
    review:
      "https://firebasestorage.googleapis.com/v0/b/cool-splice-468214-q7.firebasestorage.app/o/video%2Fclip-review-5-sd.mp4?alt=media&token=627aa40d-65f2-42fb-8c2e-1b11827f8c5d",
  },
  {
    reviewType: "text",
    review: "แซบคักแซบแหน่ ปลาแดกอีหยังมาแซบคักแท้จ้า",
    author: "คุณเมล์",
    authorImage: "https://placehold.co/36x36/2d3748/ffffff?text=M",
  },
  {
    reviewType: "video",
    review:
      "https://firebasestorage.googleapis.com/v0/b/cool-splice-468214-q7.firebasestorage.app/o/video%2Fclip-review-6-sd.mp4?alt=media&token=08240847-525f-4c53-9de8-5ce0cb499570",
  },
  {
    reviewType: "text",
    review: "ใครตำก็อร่อยค่ะ ปลาร้าเชฟไพรฑูรย์",
    author: "คุณมยุรี",
    authorImage: "https://placehold.co/36x36/2d3748/ffffff?text=M",
  },
  {
    reviewType: "text",
    review: "สะอาดอร่อย คู่ครัวจริงๆ",
    author: "คุณวัน",
    authorImage: "https://placehold.co/36x36/2d3748/ffffff?text=W",
  },
  {
    reviewType: "video",
    review:
      "https://firebasestorage.googleapis.com/v0/b/cool-splice-468214-q7.firebasestorage.app/o/video%2Fclip-review-7-sd.mp4?alt=media&token=2cfdfe19-a875-4861-b384-089ad2179a5f",
  },
  {
    reviewType: "text",
    review: "ปลาร้าเชฟไพรฑูรย์อร่อย อันดับ 1 ปรุงง่ายมาก แซบอิหลีจ้า",
    author: "คุณเดี่ยว",
    authorImage: "https://placehold.co/36x36/2d3748/ffffff?text=D",
  },
  {
    reviewType: "video",
    review:
      "https://firebasestorage.googleapis.com/v0/b/cool-splice-468214-q7.firebasestorage.app/o/video%2Fclip-review-8-sd.mp4?alt=media&token=4f910726-88a7-4929-9067-19f3f5a10e5d",
  },
  {
    reviewType: "text",
    review: "ทำเมนูไหนก็อร่อย ตั้งแต่กินปลาร้า เชฟไพรฑูรย์ อันดับ 1 เลย",
    author: "คุณ Monridee",
    authorImage: "https://placehold.co/36x36/2d3748/ffffff?text=M",
  },
  {
    reviewType: "text",
    review: "ปลาร้าเชฟไพรฑูรย์ คือความแซ่บที่ลงตัว ทำอาหารไทยแท้ๆ ได้ดีที่สุดเลยค่ะ",
    author: "คุณนภา",
    authorImage: "https://placehold.co/36x36/2d3748/ffffff?text=N",
  },
  {
    reviewType: "video",
    review:
      "https://firebasestorage.googleapis.com/v0/b/cool-splice-468214-q7.firebasestorage.app/o/video%2Fclip-review-9-sd.mp4?alt=media&token=bb1a68fc-1436-499f-97f9-6a8b99efe411",
  },
];
